var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("\n    Territory "+_vm._s(_vm.territory.territory_code)+"\n  ")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.territory))]),_vm._v(" "),_c('v-card')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }